import moment from "moment";
import BotanicalSvg from "../../../assets/ilustracoes/botanical.svg";
import NatureSvg from "../../../assets/ilustracoes/nature.svg";
import TreeSvg from "../../../assets/ilustracoes/tree.svg";

export default function EmptyState({
  maxHeight,
  maxWidth,
}: {
  maxHeight: string | number | undefined;
  maxWidth: string | number | undefined;
}) {
  switch (moment().minutes() % 3) {
    case 0:
      return (
        <img
          src={BotanicalSvg}
          style={{ maxHeight: maxHeight, maxWidth: maxWidth }}
          alt="Vazio"
        />
      );
    case 1:
      return (
        <img
          src={NatureSvg}
          style={{ maxHeight: maxHeight, maxWidth: maxWidth }}
          alt="Vazio"
        />
      );
    case 2:
    default:
      return (
        <img
          src={TreeSvg}
          style={{ maxHeight: maxHeight, maxWidth: maxWidth }}
          alt="Vazio"
        />
      );
  }
}
